<template>
  <el-dialog
    title="完成登记"
    :visible.sync="showComplete"
    width="480px"
    custom-class="CompleteDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('icon-circle-fill')" />
          <span>完成登记</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="completeBox">
        <div class="topBox">
          <svg-btn class="successSvg" icon-class="icon-check-success" />
          <span class="sufont">登记成功</span>
        </div>
        <div class="contentBox">
          <span class="title">{{
        $t("IncomeReflect.tabZero.WithdrawalRules")
      }}</span>
          <span class="content"
            >{{ $t("IncomeReflect.tabZero.TextSeven") }}</span
          >
          <span class="content"
            >{{ $t("IncomeReflect.tabZero.TextEight") }}</span
          >
          <span class="content"
            >{{ $t("IncomeReflect.tabZero.TextNine") }}</span
          >
          <!-- <span class="content"
            >4.最低提现金额：每笔提现金额不得低于 200 元人民币。</span
          > -->
        </div>
      </div>
      <div class="footer">
        <fm-button @click="handleClose" type="primary" size="small"
          >知道了</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CompleteRegis',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['showComplete'])
  },
  methods: {
    handleClose() {
      this.$store.commit('setShowComplete', false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .CompleteDialog {
  width: 560px !important;
  .el-dialog__body {
    padding: 20px 24px 32px 24px;
    .completeBox {
      margin-top: 32px;
      .topBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .successSvg {
          width: 44px;
          height: 44px;
        }
        .sufont {
          font-weight: 500;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 22px;
          margin-top: 16px;
        }
      }
      .contentBox {
        padding: 16px 13px 16px 20px;
        background: #f9f9f9;
        border-radius: 12px;
        margin-top: 34px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        .title {
          font-weight: 500;
          font-size: 16px;
          color: #2c2c2c;
          line-height: 24px;
          margin-bottom: 8px;
        }
        .content {
          font-weight: 400;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 22px;
          text-align: left;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 32px;
      .fm-button-small {
        padding: 8px 52px;
        height: 40px;
        span {
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
